import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage10: React.FC = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [otherText, setOtherText] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  useEffect(() => {
    const step9Completed = localStorage.getItem("completed-step-9");
    const step12Completed = localStorage.getItem("completed-step-12");
    if(isSermorelinPage){
      if (step12Completed) {
        navigate("/sermorelin/getting-started/step-13", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-12", { replace: true });
      }
    }else {
      if (step9Completed) {
        navigate("/nadplus/getting-started/step-10", { replace: true });
      } else {
        navigate("/nadplus/getting-started/step-9", { replace: true });
      }
    }
  }, []);

  const handleOptionClick = (option: string) => {
    if (option === "None of the above") {
      setSelectedOptions(["None of the above"]);
      setOtherText(""); 
    } else if (option === "Other") {
      if (selectedOptions.includes("Other")) {
        setSelectedOptions(selectedOptions.filter((item) => item !== "Other"));
        setOtherText("");
      } else {
        setSelectedOptions(["Other"]);
        setOtherText(""); 
      }
    } else {
      const newOptions = selectedOptions.includes(option)
        ? selectedOptions.filter((item) => item !== option)
        : [
            ...selectedOptions.filter(
              (item) => item !== "None of the above" && item !== "Other"
            ),
            option,
          ];
      setSelectedOptions(newOptions);
      if (selectedOptions.includes("Other") && !newOptions.includes("Other")) {
        setOtherText("");
      }
    }
  };

  const handleNext = () => {
    if (selectedOptions.length > 0) {
      localStorage.setItem(
        "Do_you_have_any_one_of_the_following_medical_conditions",
        JSON.stringify({
          key: "Do_you_have_any_one_of_the_following_medical_conditions",
          value: selectedOptions,
          ...(selectedOptions.includes("Other") &&
            otherText.trim() !== "" && {
              medicalConditions: otherText.trim(),
            }),
        })
      );
      if(isSermorelinPage){
        localStorage.setItem("completed-step-13", "true");
      navigate("/sermorelin/getting-started/step-14");
      }else{
      localStorage.setItem("completed-step-10", "true");
      navigate("/nadplus/getting-started/step-11");
    }
  }
  };

  useEffect(() => {
    const savedData = localStorage.getItem(
      "Do_you_have_any_one_of_the_following_medical_conditions"
    );
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        const value = parsed?.value;
        const normalizedValue = Array.isArray(value)
          ? value
          : typeof value === "string"
          ? [value]
          : [];

        setSelectedOptions(normalizedValue);
        if (parsed?.medicalConditions) setOtherText(parsed.medicalConditions);
      } catch (err) {
        console.error("Invalid localStorage data:", err);
        setSelectedOptions([]);
        setOtherText("");
      }
    }
  }, []);

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-12");
    }else{
    navigate("/nadplus/getting-started/step-9");
    }
  };

  const options = [
    "Diabetes",
    "Hypertension (high blood pressure)",
    "Heart disease",
    "Thyroid condition",
    "Asthma or COPD",
    "Anxiety/depression",
    "HIV or AIDS",
    "Kidney disease",
    "Liver disease",
    "Irregular heart rate",
    "Vascular disease (stroke, blood clots, etc)",
    "Other",
  ];

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={isSermorelinPage ? 94 : 85} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Do you have any one of the following medical conditions?
          </p>
          <div className="signup-options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>

          {selectedOptions.includes("Other") && (
            <input
              type="text"
              placeholder="Please specify other condition"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              style={{
                width: "100%",
                marginTop: "16px",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontFamily: "inherit",
              }}
            />
          )}
          <div className="signup-options" style={{ marginTop: "10px" }}>
            <label
            key={"None of the above"}
              className={selectedOptions.includes("None of the above") ? "selected" : ""}
              onClick={() => handleOptionClick("None of the above")}
            >
              None of the above
            </label>
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={
              selectedOptions.length === 0 ||
              (selectedOptions.includes("Other") && !otherText)
            }
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage10;
